import { Box } from "@circleco/compass/components/Box";
import { Typography } from "@circleco/compass/components/Typography";
import type { ReactNode } from "react";

interface SectionShellProps {
  children: ReactNode;
  title: string;
}

export const SectionShell = ({ children, title }: SectionShellProps) => (
  <Box className="flex flex-col">
    <div className="pb-6">
      <Typography variant="label-md">{title}</Typography>
    </div>
    {children}
  </Box>
);
